export default "__VITE_ASSET__CLfyw_Qz__"